module.exports = __webpack_public_path__ + "a61e045ba56c15e0b498b523656a8645.png";